import { fetchWithMemoryCache } from "../../../utils/cache/memory";
import { createHashKey } from "../../../utils";
import { withHandle, withId, withIds, withIsPreview } from "../../../types/fetch";
import { filterDocumentToSingleItem } from "../helpers";
import { fetchByParams } from "./helpers";

export async function fetchById({ id, isPreview = false, }: withIsPreview & withId) {
  const fetcher = async () => {
    const response = await fetchByParams({
      isPreview,
      queryParams: /* groq */`_id == "${id}"`,
    });
    return response;
  }

  const key = createHashKey('fetchSanityProductById', {id, isPreview})
  return isPreview ? fetcher() : fetchWithMemoryCache(key, fetcher);
}

export async function fetchByIds({ ids, isPreview = false, }: withIds & withIsPreview) {
  const fetcher = async () => {
    const response = await fetchByParams({
      isPreview,
      queryParams: /* groq */`_id in ["${ids.join('","')}"] && _type == "product"`,
    });
    return response;
  }

  if(isPreview) return fetcher();

  // 
  const products = await Promise.all(ids.map((id) => fetchById({id})));
  return products.flat().filter((v) => !!v)
}

export async function fetchByHandle({ handle, isPreview = false, }: withHandle & withIsPreview) {
  const fetcher = async () => {
    const response = await fetchByParams({
      isPreview,
      queryParams: /* groq */`store.slug.current == "${handle}" && _type == "product"`,
    });
    return filterDocumentToSingleItem(response);
  }

  const key = createHashKey('fetchSanityProductByHandle', {isPreview, handle})
  return isPreview ? fetcher() : fetchWithMemoryCache(key, fetcher);
}

export async function fetchAll(isPreview = false,) {
  const fetcher: any = () => {
    return fetchByParams({
      isPreview,
      queryParams: /* groq */`_type == "product"`,
    });
  }

  const key = createHashKey('fetchSanityProducts', {isPreview})
  return isPreview ? fetcher() : fetchWithMemoryCache(key, fetcher);
}